var _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeyser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 36.229V42.104",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 36.229V42.104",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7707 7.83329C10.7707 6.21096 12.0858 4.89579 13.7082 4.89579H33.2915C34.9138 4.89579 36.229 6.21095 36.229 7.83329V27.4166C36.229 32.2836 32.2835 36.2291 27.4165 36.2291H19.5832C14.7162 36.2291 10.7707 32.2836 10.7707 27.4166V7.83329Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7705 27.4165L10.8921 27.3355C12.7282 26.1114 14.8856 25.4582 17.0923 25.4582H17.498C18.2304 25.4582 18.9581 25.5763 19.6529 25.8079L22.6862 26.819C23.8735 27.2148 25.1169 27.4165 26.3684 27.4165V27.4165C28.9671 27.4165 31.5077 26.6473 33.6699 25.2058L36.2288 23.4999",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 15.6665,
    r: 4.89583,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.883,
    cy: 14.8835,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.508,
    cy: 14.8835,
    r: 0.597292,
    stroke: "#1C1C1C",
    strokeWidth: 1.15542
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeyser);
export default __webpack_public_path__ + "static/media/Geyser.419a8c40ad594965582034fc01606fbf.svg";
export { ForwardRef as ReactComponent };